import dayjs from 'dayjs'
import Link from 'next/link'
import Image from 'next/image'
import { ContainerWrapper } from './Container'
import { footerNavigations, NavigationTitle } from '../helpers/utils'
import StarIcon from '../Icons/footer/features/star-5.svg'
import Second from '../Icons/footer/features/2.svg'
import Third from '../Icons/footer/features/3.svg'
import Fourth from '../Icons/footer/features/4.svg'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import FooterSubscribeForm from './FooterSubscribeForm'

const List = ({ navigation }) => {
    return (
        <ul role="list" className="mt-4 space-y-4">
            {navigation.map((item) => (
                <li key={item.name}>
                    <Link href={item.href}>
                        <a
                            target={item?.target}
                            className="text-sm text-olm-black hover:text-black">
                            <NavigationTitle child={item} />
                            {/* {item.name} */}
                        </a>
                    </Link>
                </li>
            ))}
        </ul>
    )
}

const features = [
    {
        label: 'Trusted by 1,000+ Companies',
        Icon: StarIcon,
    },
    {
        label: 'Expertly Managed Direct Mail Services',
        Icon: Second,
    },
    {
        label: 'Expert Marketing Coaches',
        Icon: Third,
    },
    {
        label: 'Proven Campaigns',
        Icon: Fourth,
    },
]

export default function Footer() {
    const router = useRouter()

    useEffect(() => {
        const mailLink = document.querySelector('a#mailto')
        if (mailLink) {
            mailLink.addEventListener('click', (event) => {
                const iframe = document.createElement('iframe')
                iframe.style.display = 'none'
                iframe.src = mailLink.href

                document.body.appendChild(iframe)

                setTimeout(() => {
                    if (!iframe.hasAttribute('data-detected')) {
                        event.preventDefault()
                        router.push('/contact-us')
                    }
                    document.body.removeChild(iframe)
                }, 1000)
            })

            window.addEventListener('blur', () => {
                const iframe = document.querySelector('iframe[src^="mailto:"]')
                if (iframe) {
                    iframe.setAttribute('data-detected', 'true')
                }
            })
        }
    }, [router])

    return (
        <footer>
            <div>
                <div className="bg-white text-olm-black pt-10">
                    <div className="text-center flex justify-center mb-10 md:hidden">
                        <Link href="/">
                            <a>
                                <Image
                                    src="/assets/OLM_Logo_Primary_RGB_500px_SSf.png"
                                    alt="Open Letter Marketing"
                                    width={120}
                                    height={69.06}
                                />
                            </a>
                        </Link>
                    </div>
                    <ContainerWrapper>
                        <div className="md:flex mx-5 md:mx-0 space-y-6 md:space-y-0 gap-4 md:text-center md:gap-8">
                            {features.map((Feature, index) => (
                                <div
                                    key={index}
                                    className="items-center space-x-2 flex flex-grow">
                                    <Feature.Icon className="h-6 w-6" />
                                    <p className="text-sm font-semibold">
                                        {Feature.label}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </ContainerWrapper>
                </div>
            </div>
            <div className="text-black bg-white ff">
                <ContainerWrapper>
                    <h2 id="footer-heading" className="sr-only">
                        Open Letter Marketing
                    </h2>
                    <div className="py-10 lg:py-16">
                        <div className="grid grid-cols-2 md:grid-cols-5 gap-2 md:gap-0 mx-4 md:mx-0 ">
                            <div className="md:space-y-8 justify-between hidden md:block">
                                <Link href="/">
                                    <a>
                                        <Image
                                            src="/assets/OLM_Logo_Primary_RGB_500px_SSf.png"
                                            alt="Open Letter Marketing"
                                            width={120}
                                            height={69.06}
                                        />
                                    </a>
                                </Link>
                                <div className="space-y-4">
                                    <div className="space-y-4 pt-4">
                                        <h3 className="text-sm font-semibold">
                                            Connect
                                        </h3>
                                        <div className="flex space-x-6">
                                            {footerNavigations.social.map(
                                                (item) => (
                                                    <a
                                                        target={item.target}
                                                        key={item.name}
                                                        href={item.href}
                                                        id={item?.id}
                                                        className="text-white p-2 rounded-full bg-rtl-gradient hover:underline"
                                                        rel="noreferrer">
                                                        <span className="sr-only">
                                                            {item.name}
                                                        </span>
                                                        <item.icon
                                                            className="h-5 w-5"
                                                            aria-hidden="true"
                                                        />
                                                    </a>
                                                ),
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <h3 className="text-sm font-semibold hover:underline tracking-wider">
                                    Products
                                </h3>
                                <List navigation={footerNavigations.products} />
                            </div>
                            <div>
                                <h3 className="text-sm font-semibold hover:underline tracking-wider">
                                    Getting Started
                                </h3>
                                <List
                                    navigation={footerNavigations.resources}
                                />
                            </div>
                            <div className="mt-12 md:mt-0">
                                <h3 className="text-sm font-semibold  hover:underline tracking-wider">
                                    Discover
                                </h3>
                                <List navigation={footerNavigations.discover} />
                            </div>
                            <div className="mt-12 md:mt-0">
                                <h3 className="text-sm font-semibold  hover:underline tracking-wider">
                                    Company
                                </h3>
                                <List navigation={footerNavigations.company} />
                            </div>
                        </div>
                    </div>
                </ContainerWrapper>
            </div>

            <div className="space-y-4 pb-10 mx-4 md:hidden">
                <h3 className="text-sm font-semibold">Connect</h3>
                <div className="flex space-x-6">
                    {footerNavigations.social.map((item) => (
                        <a
                            target={item.target}
                            key={item.name}
                            href={item.href}
                            id={item?.id}
                            className="text-white p-2 rounded-full bg-rtl-gradient hover:underline"
                            rel="noreferrer">
                            <span className="sr-only">{item.name}</span>
                            <item.icon className="h-5 w-5" aria-hidden="true" />
                        </a>
                    ))}
                </div>
            </div>

            <div className="bg-rtl-gradient py-8">
                <div className="container m-auto">
                    <div className="lg:grid lg:grid-cols-3 items-end justify-center lg:justify-end space-y-5">
                        <div className="lg:col-span-2 flex justify-center lg:justify-end w-full">
                            <FooterSubscribeForm />
                        </div>
                        <div className="m-auto flex justify-center lg:items-end h-full">
                            <p className="text-sm text-white lg:text-left text-center">
                                &copy; {dayjs().format('YYYY')} Open Letter
                                Marketing, Inc. All rights reserved.
                                <br />
                                <span className="text-xs">
                                    VERSION{' '}
                                    {process.env.NEXT_PUBLIC_APP_VERSION}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
